import React from 'react';
import cn from 'classnames';

import styles from './LoadingDots.module.scss';

type LoadingDotsProps = {
  className?: string;
};

const LoadingDots: React.FC<LoadingDotsProps> = ({ className }) => {
  return (
    <div className={cn(styles['loading-dots'], className)}>
      <div className={styles['loading-dots__dot']} />
      <div className={styles['loading-dots__dot']} />
      <div className={styles['loading-dots__dot']} />
    </div>
  );
};

export default React.memo(LoadingDots);
